import { ladderAccess, levelSomewhere, servicesHome } from '@church/data'
import { atLeast } from '@church/permissions'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { DiscoverPage, SongsPills } from '../components/services/Discover.tsx'
import { useBreadcrumbs } from '../lib/breadcrumbs.ts'

/** Songs › Discover: the top Christian and gospel songs on Apple Music, and playlists. */
export const Route = createFileRoute('/_authed/_shell/services/_sections/songs/discover')({
  // Like the library: Songs Viewer and up (13-ACCESS).
  beforeLoad: ({ context }) => {
    const held = ladderAccess(context.me)
    if (!atLeast(levelSomewhere(held, 'songs'), 'viewer'))
      throw redirect({ to: servicesHome(held), replace: true })
  },
  component: DiscoverScreen,
})

function DiscoverScreen() {
  useBreadcrumbs([{ label: 'Songs', href: '/services/songs' }, { label: 'Discover' }])
  return (
    <div className="space-y-4">
      <SongsPills current="discover" />
      <DiscoverPage />
    </div>
  )
}
